import React, { useState } from 'react';
import NavBar from "../NavBar";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PlanCard from './PlanCard';
import PaymentModal from './PaymentModal';

const stripePromise = loadStripe('pk_test_51QFhxLEjMzWu0OKvQfaCpqgKICIrGejCl2rHhWn0ApJzUnNvwbbnbiynNnWuzxqlMlJkFKY2oHbXbvdLGfW5hV8A00kxk3IODY');

const Subscribe = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);

    const handlePlanSelect = (plan) => {
        setSelectedPlan(plan);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedPlan(null);
    };

    return (
        <Elements stripe={stripePromise}>
            <div className="bg-dark-main text-white-default min-h-screen font-sans">
                <NavBar />
                <section className="container mx-auto flex flex-col items-center py-20 lg:py-32">
                    <div className="lg:w-2/3 text-center p-6">
                        <h1 className="text-5xl lg:text-6xl font-extrabold mb-4 leading-tight">Upgrade Your LogBug Experience</h1>
                        <p className="text-lg lg:text-xl text-gray-400 mb-6 leading-relaxed">
                            Enhance your productivity with our advanced features. Choose the plan that best suits your needs.
                        </p>
                    </div>

                    <div className="w-full lg:w-3/2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
                        <PlanCard plan="Free Plan" price="£0/mo" features={[
                            "1 Organization Limit", "3 Project Limit", "3 Kanban Boards", "5 Team Members"
                        ]} />

                        <PlanCard plan="Basic Plan" price="£4.99/mo" features={[
                            "Custom Project Colours", "5 Organization Limit", "10 Project Limit", "10 Kanban Boards", "15 Team Members"
                        ]} onSelect={() => handlePlanSelect("Basic Plan")} />

                        <PlanCard plan="Pro Plan" price="£9.99/mo" features={[
                            "Everything in Basic", "API Access", "Unlimited Organization & Project Limit",
                            "Unlimited Kanban Boards", "Unlimited Team Members", "Advanced Role Controls", "Priority Customer Support"
                        ]} onSelect={() => handlePlanSelect("Pro Plan")} />

                        <PlanCard plan="Enterprise Plan" price="Contact us" features={[
                            "Everything in Pro", "Dedicated support", "Daily Backups", "Custom integrations"
                        ]} contactOnly />
                    </div>
                </section>

                <footer className="py-8 bg-dark-200 text-center">
                    <p className="text-gray-500">&copy; 2024 LogBug. All rights reserved.</p>
                </footer>

                {showModal && (
                    <PaymentModal plan={selectedPlan} closeModal={closeModal} />
                )}
            </div>
        </Elements>
    );
};

export default Subscribe;
